import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as outcomes from '../../outcomes'

export const RESOURCE = {
  payload: {
    description:
      'A targeted, measurable outcome that achieves progress towards a broader goal',
    dimension: outcomes.RESOURCE.payload,
    level: 2,
    name: 'Objective',
    partialId: PartialId.Standard.create('objective'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
